import { useEffect, useContext } from 'react';
import { GlobalContext } from '../context/provider';
import useMessage from '../hooks/useMessage';
import { messaging } from '../utilities/messaging/firebaseConfig';
import { getToken } from 'firebase/messaging';

const vapidKey = process.env.REACT_APP_FIREBASE_VAPID_KEY;

const FCMHandler = () => {
  const { authState } = useContext(GlobalContext);
  const { registerToken } = useMessage();

  useEffect(() => {
    const user = authState.authData;
    
    if (!user || !user.id) {
      console.log('⏳ Waiting for user authentication...');
      return;
    }

    // const registerFCM = async () => {
    //   try {
    //     const storageKey = `fcm_registered_${user.id}`;  // ✅ User-specific key
    //     const existingToken = sessionStorage.getItem(storageKey);
    //     if (existingToken) {
    //       console.log('✅ FCM already registered for user:', user.id);
    //       return;
    //     }

    //     console.log('🔔 Requesting notification permission...');
    //     await navigator.serviceWorker.ready;
        
    //     const permission = await Notification.requestPermission();
    //     console.log('📋 Permission status:', permission);

    //     if (permission === 'granted') {
    //       console.log('📱 Getting FCM token...');
    //       const fcmToken = await getToken(messaging, { vapidKey });
    //       console.log('✅ FCM token received:', fcmToken.substring(0, 20) + '...');

    //       const result = await registerToken(fcmToken);

    //       if (result.success) {
    //         console.log('✅ FCM token registered with backend');
    //         // sessionStorage.setItem('fcm_registered', 'true');
    //         sessionStorage.setItem(storageKey, 'true');  // ✅ User-specific key
    //       } else {
    //         console.error('❌ FCM registration failed:', result);
    //       }
    //     } else {
    //       console.log('⚠️ Notification permission:', permission);
    //     }
    //   } catch (error) {
    //     console.error('❌ FCM error:', error);
    //   }
    // };

    const registerFCM = async () => {
      try {
        const storageKey = `fcm_registered_${user.id}`;  // ✅ User-specific
        const existingToken = sessionStorage.getItem(storageKey);
        
        if (existingToken) {
          console.log('✅ FCM already registered for user:', user.id);
          return;
        }

        console.log('🔔 Requesting notification permission...');
        await navigator.serviceWorker.ready;
        
        const permission = await Notification.requestPermission();
        console.log('📋 Permission status:', permission);

        if (permission === 'granted') {
          console.log('📱 Getting FCM token...');
          const fcmToken = await getToken(messaging, { vapidKey });
          console.log('✅ FCM token received:', fcmToken.substring(0, 20) + '...');

          const result = await registerToken(fcmToken);

          if (result.success) {
            console.log('✅ FCM token registered with backend');
            sessionStorage.setItem(storageKey, 'true');  // ✅ User-specific key
          } else {
            console.error('❌ FCM registration failed:', result);
          }
        } else {
          console.log('⚠️ Notification permission:', permission);
        }
      } catch (error) {
        console.error('❌ FCM error:', error);
      }
    };

    registerFCM();
  }, [authState.authData, registerToken]);

  return null; // This component doesn't render anything
};

export default FCMHandler;

// ```

// ---

// ## 🧪 Test

// 1. **Clear session storage:**
//    - Open DevTools → Application → Session Storage → Clear all

// 2. **Logout and login again**

// 3. **Check console for these logs:**
// ```
//    🔔 Requesting notification permission...
//    📋 Permission status: granted
//    📱 Getting FCM token...
//    ✅ FCM token received: eyJhbGc...
//    ✅ FCM token registered with backend